import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, of, switchMap, withLatestFrom } from 'rxjs';

import {
  PageProductTransferAdminPageResponse,
  PageSiteMerchantTypesResponse,
} from '@app/api/marketplace/models';
import { MerchantsService } from '@app/api/marketplace/services';
import { PageResponse } from '@shared/interfaces/page-response.interface';

import {
  MerchantApprovalsActions,
  MerchantApprovalsSelectors,
} from './merchant-approvals.slice';

@Injectable({ providedIn: 'root' })
export class MerchantApprovalsEffects {
  getProductTakeOvers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MerchantApprovalsActions.getMerchantTypeRequests.trigger),
      withLatestFrom(
        this.store.select(MerchantApprovalsSelectors.selectFilter)
      ),
      switchMap(([_action, filter]) =>
        this.merchantsService.getMerchantTypeRequestsForAdmin(filter).pipe(
          map((response: PageProductTransferAdminPageResponse) =>
            MerchantApprovalsActions.getMerchantTypeRequests.success({
              response: response as PageResponse<PageSiteMerchantTypesResponse>,
            })
          ),
          catchError(() =>
            of(MerchantApprovalsActions.getMerchantTypeRequests.failure())
          )
        )
      )
    )
  );

  updateMerchantStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MerchantApprovalsActions.updateMerchantTypeStatus.trigger),
      switchMap((action) =>
        this.merchantsService
          .updateRequestedMerchantTypeStatus({
            body: action.request,
          })
          .pipe(
            map(() => {
              this.store.dispatch(
                MerchantApprovalsActions.getMerchantTypeRequests.trigger()
              );
              return MerchantApprovalsActions.updateMerchantTypeStatus.success();
            }),
            catchError(() =>
              of(MerchantApprovalsActions.updateMerchantTypeStatus.failure())
            )
          )
      )
    )
  );

  constructor(
    private readonly store: Store,
    private readonly actions$: Actions,
    private readonly merchantsService: MerchantsService
  ) {}
}
